export const API_ROUTES = {
  ELASTIC_SEARCH: `/es/photoarchive-rt/_search`,
  AUTH: {
    BASE: '/auth',
    LOGIN: '/auth/login',
    TOTP_VERIFY: '/auth/totp/verify',
    REFRESH: '/auth/refresh',
    RESET_PASSWORD: '/auth/restore',
    RESET_TOTP: '/auth/totp/disable',
    UPDATE_USER: '/auth/status/change',
    UPDATE_USER_INFO: '/auth/edit',
    RESET_TOKEN: '/auth/token/static/update',
    CREATE_USER: '/auth/create',
  },
} as const;
